import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useI18n } from "@/i18n";

export default function AuthCallback() {
  const nav = useNavigate();
  const location = useLocation();
  const { setUser, applyUserLang } = useAuth();
  const { t } = useI18n();
  const hasProcessed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    if (!sessionId) { nav("/login", { replace: true }); return; }

    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        setUser(data.user);
        applyUserLang(data.user);
        window.history.replaceState(null, "", window.location.pathname);
        nav(data.user.onboarded ? "/dashboard" : "/onboarding", { replace: true });
      } catch {
        setError("Authentifizierung fehlgeschlagen.");
        setTimeout(() => nav("/login", { replace: true }), 1500);
      }
    })();
  }, [location.hash, nav, setUser, applyUserLang]);

  return (
    <div className="min-h-screen flex items-center justify-center text-ink-soft" data-testid="auth-callback">
      {error || t("common.loading")}
    </div>
  );
}
